import Auth from '../api/auth';
import { getOtelloConfig } from './browserNavigation';

const parseErrorCode = (error) => Promise.reject(error);

// Gli header della sessione del pannello (devise_token_auth). Servono anche
// fuori da axios, per esempio agli direct_uploads di Active Storage.
export const getSessionAuthHeaders = (auth = Auth) => {
  if (!auth?.hasAuthCookie?.()) {
    return {};
  }
  const {
    'access-token': accessToken,
    'token-type': tokenType,
    client,
    expiry,
    uid,
  } = auth.getAuthData() || {};
  return {
    'access-token': accessToken,
    'token-type': tokenType,
    client,
    expiry,
    uid,
  };
};

export default (axios) => {
  const { apiHost = '' } = getOtelloConfig();
  const otelloApi = axios.create({ baseURL: `${apiHost}/` });
  // Add Auth Headers to requests if logged in
  Object.assign(otelloApi.defaults.headers.common, getSessionAuthHeaders());
  // Response parsing interceptor
  otelloApi.interceptors.response.use(
    (response) => response,
    (error) => parseErrorCode(error)
  );
  return otelloApi;
};
